/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/** * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */
export const UPDATE_SHIPPING_ADDRESS = 'UPDATE_SHIPPING_ADDRESS';
export const UPDATE_SHIPPING_METHOD_CODE = 'UPDATE_SHIPPING_METHOD_CODE';
export const UPDATE_PAYMENT_METHOD_CODE = 'UPDATE_PAYMENT_METHOD_CODE';
export const UPDATE_BILLING_IS_SAME_AS_SHIPPING = 'UPDATE_BILLING_IS_SAME_AS_SHIPPING';
export const UPDATE_BILLING_ADDRESS_ID = 'UPDATE_BILLING_ADDRESS_ID';
export const UPDATE_BILLING_ADDRESS = 'UPDATE_BILLING_ADDRESS';
export const UPDATE_CLIENT_TYPE = 'UPDATE_CLIENT_TYPE';
export const RESET_CHECKOUT_FIELDS = 'RESET_CHECKOUT_FIELDS';
export const UPDATE_CUSTOM_ADDRESS_EXPANDED = 'UPDATE_CUSTOM_ADDRESS_EXPANDED';

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Action/updateShippingAddress */
export const updateShippingAddress = (shippingAddressFields) => ({
    type: UPDATE_SHIPPING_ADDRESS,
    shippingAddressFields
});

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Action/updateCustomAddressExpanded */
export const updateCustomAddressExpanded = (isCustomAddressExpanded) => ({
    type: UPDATE_CUSTOM_ADDRESS_EXPANDED,
    isCustomAddressExpanded
});

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Action/updateShippingMethodCode */
export const updateShippingMethodCode = (shippingMethodCode) => ({
    type: UPDATE_SHIPPING_METHOD_CODE,
    shippingMethodCode
});

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Action/updatePaymentMethodCode */
export const updatePaymentMethodCode = (paymentMethodCode) => ({
    type: UPDATE_PAYMENT_METHOD_CODE,
    paymentMethodCode
});

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Action/updateBillingSameAsShipping */
export const updateBillingSameAsShipping = (billingSameAsShipping) => ({
    type: UPDATE_BILLING_IS_SAME_AS_SHIPPING,
    billingSameAsShipping
});

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Action/updateBillingAddressId */
export const updateBillingAddressId = (billingAddressId) => ({
    type: UPDATE_BILLING_ADDRESS_ID,
    billingAddressId
});

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Action/updateClientType */
export const updateClientType = (clientType) => ({
    type: UPDATE_CLIENT_TYPE,
    clientType
});

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Action/updateBillingAddress */
export const updateBillingAddress = (billingAddressFields) => ({
    type: UPDATE_BILLING_ADDRESS,
    billingAddressFields
});

/** @namespace Satisfly/CheckoutSavedFormFields/Store/CheckoutFields/Action/resetCheckoutFields */
export const resetCheckoutFields = () => ({
    type: RESET_CHECKOUT_FIELDS
});
